import { auditEventDTOSchema, auditLogAccessDTOSchema, } from '@instanexus/contracts';
import { dataEnvelopeSchema, listEnvelopeSchema, WEB_API_PREFIX, } from '../transport.js';
const listAuditEventsSchema = listEnvelopeSchema(auditEventDTOSchema);
const accessSchema = dataEnvelopeSchema(auditLogAccessDTOSchema);
const eventSchema = dataEnvelopeSchema(auditEventDTOSchema);
export function createAuditEventsResource(transport) {
    return {
        async list(params = {}) {
            return transport.request({
                path: `${WEB_API_PREFIX}/audit-events`,
                schema: listAuditEventsSchema,
                query: {
                    page: params.page,
                    pageSize: params.pageSize,
                    sort: params.sort,
                    action: params.action,
                    actorUserId: params.actorUserId,
                    from: params.from,
                    to: params.to,
                },
            });
        },
        async access() {
            const envelope = await transport.request({
                path: `${WEB_API_PREFIX}/audit-events/access`,
                schema: accessSchema,
            });
            return envelope.data;
        },
        async get(id) {
            const envelope = await transport.request({
                path: `${WEB_API_PREFIX}/audit-events/${encodeURIComponent(id)}`,
                schema: eventSchema,
            });
            return envelope.data;
        },
        async exportCsv(params = {}) {
            return transport.requestText({
                path: `${WEB_API_PREFIX}/audit-events/export`,
                accept: 'text/csv',
                query: {
                    action: params.action,
                    actorUserId: params.actorUserId,
                    from: params.from,
                    to: params.to,
                },
            });
        },
    };
}
//# sourceMappingURL=audit-events.js.map